import { HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DashboardHttpService } from '../../../core-services/dashboard-http-service/dashboard-http.service';
import { GetOptions } from '../../../core-services/models';
import {
  AffiliateApplication,
  AffiliateApplicationRequest,
  AffiliateApplicationStatus, Paged
} from '../../dtos/api';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationsApiService {
  constructor(private http: DashboardHttpService) { }

  private baseUrl = environment.apiUrl + '/applications';

  getAffiliateApplication(id: string, options: GetOptions = {}) {
    let url = this.baseUrl + id + '/affiliates/';
    return this.http.getWithOptions<AffiliateApplication>(url, options);
  }

  getAffiliateApplicationByAffiliateId(affiliateId: string, options: GetOptions = {}) {
    let url = this.baseUrl + '/affiliates/' + affiliateId;
    return this.http.getWithOptions<AffiliateApplication>(url, options).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404 && error?.error?.error_key === 'api.model.affiliate_applications.not_found') {
          return of<AffiliateApplication>(<AffiliateApplication>{});
        }
        throw error;
      })
    );
  }

  getAffiliateApplicationByWebsiteUrl(websiteUrl: string = null, application_statuses: AffiliateApplicationStatus[] = []) {
    let url = this.baseUrl + '/affiliates/search';
    let params = new HttpParams();
    if (websiteUrl) {
      params = params.set('application_website_url', websiteUrl);
    }
    if (application_statuses.length > 0) {
      params = params.set('application_statuses', application_statuses.join(','));
    }

    const options: GetOptions = {
      params
    };

    return this.http.getWithOptions<Paged<AffiliateApplication>>(url, options).pipe(map(x => x.items));
  }

  createAffiliateApplication(createAffiliateApplicationRequest: AffiliateApplicationRequest) {
    return this.http.postWithOptions<AffiliateApplication>(`${this.baseUrl}/affiliates`, createAffiliateApplicationRequest);
  }

  updateAffiliateApplication(affiliateApplication: AffiliateApplication, id: string, options: GetOptions = {}) {
    let url = `${this.baseUrl}/${id}/affiliates`;
    return this.http.putWithOptions<AffiliateApplication>(url, affiliateApplication, options);
  }

  confirmApplicationWithSocialMedia(affiliateApplicationId: string, instagramAuthCode: string, instagramRedirectUri: string, apiToken: string) {
    let url = `${this.baseUrl}/${affiliateApplicationId}/affiliates/confirm-with-social-media`;

    let body = {
      auth_code: instagramAuthCode,
      redirect_uri: instagramRedirectUri
    };

    let options: GetOptions = { headers: new HttpHeaders({authorization: apiToken}) };

    return this.http.postWithOptions<AffiliateApplication>(url, body, options);
  }
}
